import * as requestFromServer from "./DesignStudioCrud"
import { DesignStudioSlice, callTypes } from "./DesignStudioSlice"
import { profileSlice } from "../../../../redux/profile/profileSlice"
import { convertCollectionSnapshotToMap } from "../../_helpers/ActionHelpers"
import { firebaseLooper } from "../../_helpers/ActionHelpers"
import { firestore as db } from "../../../../../firebase"
import firebase from "firebase/compat/app"
import * as turf from "@turf/turf"
import { collection, doc, setDoc, updateDoc, GeoPoint } from "firebase/firestore"

const { actions } = DesignStudioSlice

export const updateUrlsFromDB = queryParams => dispatch => {
	dispatch(actions.startCall({ callType: callTypes.action }))
	// console.log(queryParams, "params actions");

	const promises = []
	var features = queryParams.data.map(val => {
		const coordinates = val.geoJson.geometry.coordinates[0].map(v => {
			return new firebase.firestore.GeoPoint(v[1], v[0])
		})
		var zoneId = null

		zoneId = val.geoJson.properties.zoneId
		const zoneIdFromDB = queryParams.zoneToUpdateUrls[0].id

		return {
			...val.geoJson,
			properties: {
				name: val.name,
				type: val.type,
				capacity: val.capacity,
				zoneId: zoneId,
				zoneImagesUrls:
					zoneId === zoneIdFromDB
						? queryParams.newImagesUrls
						: val.geoJson.properties.zoneImagesUrls || null
			},
			geometry: {
				type: val.geoJson.geometry.type,
				coordinates
			}
		}
	})

	var newParams = {
		...queryParams,
		geoJson: {
			type: "FeatureCollection",
			features: features
		},
		promises
	}

	return requestFromServer
		.updateUrls(newParams)
		.then(response => {
			dispatch({
				type: "SNACKBAR_SUCCESS",
				payload: {
					message: "Image deleted successfully"
				}
			})
		})
		.catch(error => {
			console.log("Error: ", error)
			error.clientMessage = "Can't delete image"
			dispatch({
				type: "SNACKBAR_ERROR",
				payload: {
					message: "Error uploading images"
				}
			})
			dispatch(actions.catchError({ error, callType: callTypes.action }))
		})
}

export const getUrlsFromDB = queryParams => dispatch => {
	dispatch(actions.startCall({ callType: callTypes.list }))

	if (!queryParams) {
		dispatch(actions.zonesInDBFetched({ entities: [] }))
	}

	return requestFromServer
		.getZonesInDB(queryParams)
		.then(response => {
			if (!response) {
				throw Error("Can't make a request for server")
			}

			// const zones = convertCollectionSnapshotToMap(response)
			const zones = response
			// console.log("🚀 ~ zones", zones);

			dispatch(actions.zonesInDBFetched({ entities: zones }))
		})
		.catch(error => {
			console.log("fetch zones from DB ", error)
			error.clientMessage = "Can't find  zones in DB"
			dispatch(actions.catchError({ error, callType: callTypes.list }))
		})
}

export const saveUrlsToDB = queryParams => dispatch => {
	// dispatch(actions.startCall({ callType: callTypes.action }));

	const zoneFetched = queryParams.zonesFetchedFromDB.find(
		zone => zone.id === queryParams.row.geoJson.properties.zoneId
	)

	const oldImages = zoneFetched.imagesUrls ? zoneFetched.imagesUrls : []

	let imagesSummed = [...oldImages]

	queryParams.result.forEach(res => {
		imagesSummed.push(res)
	})

	const promises = []
	var features = queryParams.data.map(val => {
		const coordinates = val.geoJson.geometry.coordinates[0].map(v => {
			return new firebase.firestore.GeoPoint(v[1], v[0])
		})
		var zoneId = null

		zoneId = val.geoJson.properties.zoneId

		return {
			...val.geoJson,
			properties: {
				name: val.name,
				type: val.type,
				capacity: val.capacity,
				zoneId: zoneId,
				zoneImagesUrls:
					zoneId === zoneFetched.id
						? imagesSummed
						: val.geoJson.properties.zoneImagesUrls || null
			},
			geometry: {
				type: val.geoJson.geometry.type,
				coordinates
			}
		}
	})

	var newParams = {
		...queryParams,
		geoJson: {
			type: "FeatureCollection",
			features: features
		},
		promises
	}

	return requestFromServer
		.saveUrls(newParams)
		.then(response => {
			dispatch({
				type: "SNACKBAR_SUCCESS",
				payload: {
					message: "Images uploaded successfully"
				}
			})
		})
		.catch(error => {
			console.log("Error: ", error)
			error.clientMessage = "Can't updload images"
			dispatch({
				type: "SNACKBAR_ERROR",
				payload: {
					message: "Error uploading images"
				}
			})
			dispatch(actions.catchError({ error, callType: callTypes.action }))
		})
}

// export const saveAreasAndGeoJson = queryParams => dispatch => {
// 	dispatch(actions.startCall({ callType: callTypes.action }))

// 	// console.log(queryParams, "params actions add zones");

// 	const promises = []
// 	const features = queryParams.data.map(val => {
// 		const coordinates = val.geoJson.geometry.coordinates[0].map(v => {
// 			// console.log(v, "v zones");
// 			return new firebase.firestore.GeoPoint(v[1], v[0])
// 		})
// 		var areaId = null

// 		// ↓ Info and Door Markers
// 		// Door marker coords
// 		const point1 = turf.point(val.geoJson.geometry.coordinates[0][0])
// 		const point2 = turf.point(val.geoJson.geometry.coordinates[0][1])
// 		const midpoint = turf.midpoint(point1, point2)
// 		const midPointLng = midpoint.geometry.coordinates[0]
// 		const midPointLat = midpoint.geometry.coordinates[1]

// 		// Info marker coords inside polygon (Have a marker coords by default)
// 		const poly2 = turf.polygon(val.geoJson.geometry.coordinates)
// 		const pointOnPolygon = turf.pointOnFeature(poly2) // ← Get point inside each polygon.
// 		const pointOnPolygonLng = pointOnPolygon.geometry.coordinates[0]
// 		const pointOnPolygonLat = pointOnPolygon.geometry.coordinates[1]

// 		// Fetch coords if marker coords already exist on each zone and render conditionally
// 		// Zone in DB with same id as feature
// 		const fetchZoneWithMarkerCoords =
// 			queryParams.zonesFetchedFromDB &&
// 			queryParams.zonesFetchedFromDB.find(area => area.id === val.geoJson.properties.areaId)

// 		// Conditionally door markers
// 		const fetchedLngDoor = fetchZoneWithMarkerCoords?.doorMarker?.longitude
// 		const fetchedLatDoor = fetchZoneWithMarkerCoords?.doorMarker?.latitude
// 		const conditionalLngDoor = fetchedLngDoor ? fetchedLngDoor : midPointLng
// 		const conditionalLatDoor = fetchedLatDoor ? fetchedLatDoor : midPointLat

// 		// Conditionally info markers
// 		const fetchedLng = fetchZoneWithMarkerCoords?.marker?.longitude
// 		const fetchedLat = fetchZoneWithMarkerCoords?.marker?.latitude
// 		const conditionalLng = fetchedLng ? fetchedLng : pointOnPolygonLng
// 		const conditionalLat = fetchedLat ? fetchedLat : pointOnPolygonLat

// 		const value = {
// 			color: val.color,
// 			name: val.name,
// 			type: val.type,
// 			capacity: val.capacity,
// 			polygon: coordinates,
// 			floorPlanId: queryParams.floorPlanId,
// 			networkId: queryParams.networkId,
// 			marker: new firebase.firestore.GeoPoint(conditionalLat, conditionalLng),
// 			doorMarker: new firebase.firestore.GeoPoint(conditionalLatDoor, conditionalLngDoor),
// 			visible: val.visible,
// 			geoFencing: val.geoFencing,
// 			altitude: queryParams.floorPlan?.coords?.bottomLeftCorner?.altitude
// 				? queryParams.floorPlan?.coords?.bottomLeftCorner?.altitude
// 				: 0 // Altitude to Wirepas
// 			// referencePoints: val.geoJson.properties?.referencePoints || null, // Reference Points to Wirepas
// 		}

// 		if (val.type === "baseLayer") {
// 		} else if (val.geoJson.properties.areaId) {
// 			const ref = firestoreOld
// 				.collection("Sites")
// 				.doc(queryParams.networkId)
// 				.collection("Areas")
// 				.doc(val.geoJson.properties.areaId)
// 			areaId = val.geoJson.properties.areaId

// 			promises.push(ref.update(value))
// 			// promises.push(ref.set(value));
// 		} else {
// 			const ref = firestoreOld
// 				.collection("Sites")
// 				.doc(queryParams.networkId)
// 				.collection("Areas")
// 				.doc()
// 			areaId = ref.id
// 			promises.push(ref.set(value))
// 		}

// 		return {
// 			...val.geoJson,
// 			properties: {
// 				name: val.name,
// 				type: val.type,
// 				capacity: Number(val.capacity),
// 				areaId: areaId,
// 				zoneImagesUrls: val.geoJson.properties?.zoneImagesUrls
// 					? val.geoJson.properties?.zoneImagesUrls
// 					: [],
// 				// zoneImagesUrls: firebase.firestore.FieldValue.arrayUnion(
// 				//   ...queryParams.zoneImagesUrls
// 				// ),
// 				visible: val.visible,
// 				geoFencing: val.geoFencing,
// 				altitude: queryParams.floorPlan?.coords?.bottomLeftCorner?.altitude
// 					? queryParams.floorPlan?.coords?.bottomLeftCorner?.altitude
// 					: 0 // Altitude to Wirepas
// 				// referencePoints: val.geoJson.properties?.referencePoints || null, // Reference Points to Wirepas
// 			},
// 			geometry: {
// 				type: val.geoJson.geometry.type,
// 				coordinates
// 			}
// 		}
// 	})

// 	var newParams = {
// 		...queryParams,
// 		geoJson: {
// 			type: "FeatureCollection",
// 			features: features
// 		},
// 		promises
// 	}

// 	return requestFromServer
// 		.saveGeoJson(newParams)
// 		.then(response => {
// 			dispatch({
// 				type: "SNACKBAR_SUCCESS",
// 				payload: `Saved successfully`
// 			})
// 		})
// 		.catch(error => {
// 			console.log("Error: ", error)
// 			error.clientMessage = "Can't save"
// 			dispatch({
// 				type: "SNACKBAR_ERROR",
// 				payload: `Error saving`
// 			})
// 			dispatch(actions.catchError({ error, callType: callTypes.action }))
// 		})
// }

export const saveAreasAndGeoJson = queryParams => async dispatch => {
	dispatch(actions.startCall({ callType: callTypes.action }))

	const promises = []

	const features = queryParams.data.map(val => {
		const coordinates = val.geoJson.geometry.coordinates[0].map(v => {
			return new GeoPoint(v[1], v[0])
		})

		let areaId = null

		// Info and Door Markers
		const point1 = turf.point(val.geoJson.geometry.coordinates[0][0])
		const point2 = turf.point(val.geoJson.geometry.coordinates[0][1])
		const midpoint = turf.midpoint(point1, point2)
		const midPointLng = midpoint.geometry.coordinates[0]
		const midPointLat = midpoint.geometry.coordinates[1]

		const poly2 = turf.polygon(val.geoJson.geometry.coordinates)
		const pointOnPolygon = turf.pointOnFeature(poly2)
		const pointOnPolygonLng = pointOnPolygon.geometry.coordinates[0]
		const pointOnPolygonLat = pointOnPolygon.geometry.coordinates[1]

		const fetchZoneWithMarkerCoords =
			queryParams.zonesFetchedFromDB &&
			queryParams.zonesFetchedFromDB.find(area => area.id === val.geoJson.properties.areaId)

		const fetchedLngDoor = fetchZoneWithMarkerCoords?.doorMarker?.longitude
		const fetchedLatDoor = fetchZoneWithMarkerCoords?.doorMarker?.latitude
		const conditionalLngDoor = fetchedLngDoor ? fetchedLngDoor : midPointLng
		const conditionalLatDoor = fetchedLatDoor ? fetchedLatDoor : midPointLat

		const fetchedLng = fetchZoneWithMarkerCoords?.marker?.longitude
		const fetchedLat = fetchZoneWithMarkerCoords?.marker?.latitude
		const conditionalLng = fetchedLng ? fetchedLng : pointOnPolygonLng
		const conditionalLat = fetchedLat ? fetchedLat : pointOnPolygonLat

		const value = {
			color: val.color,
			name: val.name,
			type: val.type,
			capacity: val.capacity,
			polygon: coordinates,
			floorPlanId: queryParams.floorPlanId,
			networkId: queryParams.networkId,
			marker: new GeoPoint(conditionalLat, conditionalLng),
			doorMarker: new GeoPoint(conditionalLatDoor, conditionalLngDoor),
			visible: val.visible,
			geoFencing: val.geoFencing,
			altitude: queryParams.floorPlan?.coords?.bottomLeftCorner?.altitude
				? queryParams.floorPlan?.coords?.bottomLeftCorner?.altitude
				: 0
		}

		if (val.type === "baseLayer") {
			// Do nothing for baseLayer type
		} else if (val.geoJson.properties.areaId) {
			const ref = doc(db, "Sites", queryParams.networkId, "Areas", val.geoJson.properties.areaId)
			areaId = val.geoJson.properties.areaId

			promises.push(updateDoc(ref, value))
		} else {
			const ref = doc(collection(db, "Sites", queryParams.networkId, "Areas"))
			areaId = ref.id
			promises.push(setDoc(ref, value))
		}

		return {
			...val.geoJson,
			properties: {
				name: val.name,
				type: val.type,
				capacity: Number(val.capacity),
				areaId: areaId,
				zoneImagesUrls: val.geoJson.properties?.zoneImagesUrls
					? val.geoJson.properties?.zoneImagesUrls
					: [],
				visible: val.visible,
				geoFencing: val.geoFencing,
				altitude: queryParams.floorPlan?.coords?.bottomLeftCorner?.altitude
					? queryParams.floorPlan?.coords?.bottomLeftCorner?.altitude
					: 0
			},
			geometry: {
				type: val.geoJson.geometry.type,
				coordinates
			}
		}
	})

	const newParams = {
		...queryParams,
		geoJson: {
			type: "FeatureCollection",
			features: features
		},
		promises
	}

	try {
		await requestFromServer.saveGeoJson(newParams)
		dispatch({
			type: "SNACKBAR_SUCCESS",
			payload: `Saved successfully`
		})
	} catch (error) {
		console.log("Error: ", error)
		error.clientMessage = "Can't save"
		dispatch({
			type: "SNACKBAR_ERROR",
			payload: `Error saving`
		})
		dispatch(actions.catchError({ error, callType: callTypes.action }))
	}
}

export const saveLayerTypes = queryParams => dispatch => {
	dispatch(actions.startCall({ callType: callTypes.action }))

	// console.log(queryParams, "queryParams saveLayerTypes nas Actions");

	return requestFromServer
		.saveLayerTypes(queryParams)
		.then(response => {
			dispatch(profileSlice.actions.layerTypesFetched(queryParams.layerTypes))

			// doesn't dispatch success message when creating default layer type
			if (queryParams.layerTypes.length !== 1) {
				dispatch({
					type: "SNACKBAR_SUCCESS",
					payload: {
						message: "Area types saved successfully"
					}
				})
			}
		})
		.catch(error => {
			console.log("Error: ", error)
			error.clientMessage = "Can't save"
			dispatch({
				type: "SNACKBAR_ERROR",
				payload: {
					message: "Error saving area types"
				}
			})
			dispatch(actions.catchError({ error, callType: callTypes.action }))
		})
}

export const deleteLayerTypes = queryParams => dispatch => {
	dispatch(actions.startCall({ callType: callTypes.action }))

	return requestFromServer
		.deleteLayerTypes(queryParams)
		.then(response => {
			dispatch({
				type: "SNACKBAR_SUCCESS",
				payload: {
					message: "Area type delete successfully"
				}
			})
		})
		.catch(error => {
			console.log("Error: ", error)
			error.clientMessage = "Can't delete"
			dispatch({
				type: "SNACKBAR_ERROR",
				payload: {
					message: "Error deleting area types"
				}
			})

			dispatch(actions.catchError({ error, callType: callTypes.action }))
		})
}

export const updateLayerTypes = queryParams => dispatch => {
	dispatch(actions.startCall({ callType: callTypes.action }))

	// console.log(queryParams, "queryParams updateLayerTypes nas Actions");

	return requestFromServer
		.updateLayerTypes(queryParams)
		.then(response => {
			dispatch({
				type: "SNACKBAR_SUCCESS",
				payload: {
					message: "Area types updates successfully"
				}
			})
		})
		.catch(error => {
			console.log("Error: ", error)
			error.clientMessage = "Can't update"
			dispatch({
				type: "SNACKBAR_ERROR",
				payload: {
					message: "Error updating area types"
				}
			})
			dispatch(actions.catchError({ error, callType: callTypes.action }))
		})
}

export const saveZoneMarkers = queryParams => dispatch => {
	// dispatch(actions.startCall({ callType: callTypes.action }));
	return requestFromServer
		.saveMarkersFromZones(queryParams)
		.then(response => {})
		.catch(error => {
			console.log("Error: ", error)
			error.clientMessage = "Can't save marker coordinates"
			dispatch({
				type: "SNACKBAR_ERROR",
				payload: {
					message: "Error saving marker coordinates"
				}
			})
			dispatch(actions.catchError({ error, callType: callTypes.action }))
		})
}

export const saveZoneDoorMarkers = queryParams => dispatch => {
	// dispatch(actions.startCall({ callType: callTypes.action }));
	return requestFromServer
		.saveDoorMarkersFromZones(queryParams)
		.then(response => {})
		.catch(error => {
			console.log("Error: ", error)
			error.clientMessage = "Can't save marker coordinates"
			dispatch({
				type: "SNACKBAR_ERROR",
				payload: {
					message: "Error saving marker coordinates."
				}
			})
			dispatch(actions.catchError({ error, callType: callTypes.action }))
		})
}

export const deleteZonesFromDB = queryParams => dispatch => {
	dispatch(actions.startCall({ callType: callTypes.action }))

	// console.log(queryParams, "params actions");

	const filteredData = queryParams.data.filter(val => val.id !== queryParams.zoneToDelete.id)

	var features = filteredData.map(val => {
		const coordinates = val.geoJson.geometry.coordinates[0].map(v => {
			return new firebase.firestore.GeoPoint(v[1], v[0])
		})

		return {
			...val.geoJson,
			properties: {
				name: val.name,
				type: val.type,
				capacity: val.capacity,
				areaId: val.geoJson.properties.areaId,
				zoneImagesUrls: val.geoJson.properties.zoneImagesUrls || null
			},
			geometry: {
				type: val.geoJson.geometry.type,
				coordinates
			}
		}
	})

	// console.log(filteredData, "filteredData");
	// console.log(features, "features");

	var newParams = {
		...queryParams,
		geoJson: {
			type: "FeatureCollection",
			features: features
		}
	}

	return requestFromServer
		.deleteZones(newParams)
		.then(response => {})
		.catch(error => {
			console.log("Error: ", error)
			error.clientMessage = "Can't delete"
			dispatch({
				type: "SNACKBAR_ERROR",
				payload: {
					message: "Error deleting areas"
				}
			})
			dispatch(actions.catchError({ error, callType: callTypes.action }))
		})
}

export const fetchResourcesMeetings = queryParams => dispatch => {
	dispatch(actions.startCall({ callType: callTypes.list }))

	if (!queryParams) {
		dispatch(actions.resourcesMeetingsFetched({ entities: [] }))
	}

	return requestFromServer
		.getResourcesMeetings(queryParams)
		.then(response => {
			if (!response) {
				throw Error("Can't make a request for server")
			}

			const resources = response
			// console.log(resources, "resources");
			dispatch(actions.resourcesMeetingsFetched({ entities: resources }))
		})
		.catch(error => {
			console.log("fetch resources meetings", error)
			error.clientMessage = "Can't find resources meetings"
			dispatch(actions.catchError({ error, callType: callTypes.list }))
		})
}

//★━━━━━━━━━★ Points of Interest ACTIONS ★━━━━━━━━━★\\
//★━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━★\\

export const createPointOfInterest = queryParams => dispatch => {
	dispatch(actions.startCall({ callType: callTypes.action }))

	return requestFromServer
		.createPointOfInterest(queryParams)
		.then(res => {
			dispatch(
				actions.poiCreated({
					name: queryParams.data.name,
					description: queryParams.data.description,
					type: queryParams.data.type,
					imagesUrls: queryParams.imagesUrls,
					siteId: queryParams.siteId,
					created: {
						id: queryParams.user.id,
						email: queryParams.user.email,
						date: firebase.firestore.FieldValue.serverTimestamp()
					},
					floorPlanId: queryParams.floorPlanId,
					coords: queryParams.coords,
					markerVisible: queryParams.markerVisible,
					id: res || ""
				})
			)
			dispatch({
				type: "SNACKBAR_SUCCESS",
				payload: {
					message: "Point of Interest created"
				}
			})
			return res
		})
		.catch(error => {
			error.clientMessage = "Can't create Point of Interest"
			dispatch(actions.catchError({ error, callType: callTypes.action }))
		})
}

export const updatePointOfInterest = queryParams => dispatch => {
	dispatch(actions.startCall({ callType: callTypes.action }))

	return requestFromServer
		.updatePointOfInterest(queryParams)
		.then(res => {
			const updatedPOI = {
				...queryParams.data,
				name: queryParams.data.name,
				description: queryParams.data.description,
				type: queryParams.data.type,
				imagesUrls: queryParams.newImagesUrlsArray,
				siteId: queryParams.siteId,
				updated: {
					id: queryParams.user.id,
					email: queryParams.user.email,
					date: firebase.firestore.FieldValue.serverTimestamp()
				},
				markerVisible: queryParams.data.markerVisible
			}

			dispatch(actions.poiEdited(updatedPOI))

			dispatch({
				type: "SNACKBAR_SUCCESS",
				payload: {
					message: "Point of Interest updated"
				}
			})
			return res
		})
		.catch(error => {
			console.log(error, "error")
			error.clientMessage = "Can't update Point of Interest"
			dispatch(actions.catchError({ error, callType: callTypes.action }))
		})
}

export const savePointsOfInterest = queryParams => dispatch => {
	dispatch(actions.startCall({ callType: callTypes.action }))
	return requestFromServer
		.savePointsOfInterest(queryParams)
		.then(() => {
			dispatch({
				type: "SNACKBAR_SUCCESS",
				payload: {
					message: "Point of Interest saved"
				}
			})
		})
		.catch(error => {
			error.clientMessage = "Can't save Points of Interest"
			dispatch(actions.catchError({ error, callType: callTypes.action }))
		})
}

export const savePOIsSingleMarkers = queryParams => dispatch => {
	dispatch(actions.startCall({ callType: callTypes.action }))

	return requestFromServer
		.saveMarkersFromPOIs(queryParams)
		.then(response => {
			const updatedPOI = {
				...queryParams.marker,
				coords: queryParams.marker.coords || "",
				floorPlanId: queryParams.marker.floorPlanId || ""
			}

			dispatch(actions.poiEdited(updatedPOI))
		})
		.catch(error => {
			console.log("Error: ", error)
			error.clientMessage = "Can't save marker coordinates"
			dispatch({
				type: "SNACKBAR_ERROR",
				payload: {
					message: "Error saving marker coordinates"
				}
			})
			dispatch(actions.catchError({ error, callType: callTypes.action }))
		})
}

// export const savePOIsMarkerVisible = (queryParams) => (dispatch) => {
//   dispatch(actions.startCall({ callType: callTypes.action }));

//   return requestFromServer
//     .saveMarkerVisibilityFromPOIs(queryParams)
//     .then((response) => {})
//     .catch((error) => {
//       console.log("Error: ", error);
//       error.clientMessage = "Can't save marker visibility";
//       dispatch({
//         type: "SNACKBAR_ERROR",
//         payload: `Error saving marker visibility.`,
//       });
//       dispatch(actions.catchError({ error, callType: callTypes.action }));
//     });
// };

export const fetchPointsOfInterest = queryParams => dispatch => {
	dispatch(actions.startCall({ callType: callTypes.list }))

	if (!queryParams) {
		dispatch(actions.pointsOfInterestFetched({ entities: [] }))
	}

	return requestFromServer
		.getPointsOfInterest(queryParams)
		.then(response => {
			if (!response) {
				throw Error("Can't make a request for server")
			}

			// const pointsOfInterest = convertCollectionSnapshotToMap(response)
			const pointsOfInterest = response

			dispatch(actions.pointsOfInterestFetched({ entities: pointsOfInterest }))
		})
		.catch(error => {
			console.log("fetch points of interest ", error)
			error.clientMessage = "Can't find points of interest"
			dispatch(actions.catchError({ error, callType: callTypes.list }))
		})
}

export const deletePointOfInterest = queryParams => dispatch => {
	dispatch(actions.startCall({ callType: callTypes.action }))
	return requestFromServer
		.deletePointOfInterest(queryParams)
		.then(response => {
			dispatch(actions.pointOfInterestDeleted({ id: queryParams.id }))

			dispatch({
				type: "SNACKBAR_SUCCESS",
				payload: `Point of Interest ${queryParams.name} deleted`
			})
		})
		.catch(error => {
			error.clientMessage = "Can't delete product"
			dispatch(actions.catchError({ error, callType: callTypes.action }))
		})
}

export const fetchToUpdatePointOfInterestAction = queryParams => dispatch => {
	dispatch(actions.startCall({ callType: callTypes.action }))
	if (!queryParams) {
		dispatch(actions.pointOfInterestFetchedToUpdate({ entities: [] }))
	}

	return requestFromServer
		.getPointOfInterestToUpdate(queryParams)
		.then(response => {
			if (!response) {
				throw Error("Can't make a request for server")
			}

			// const pointOfInterestResponse = response.data()
			const pointOfInterestResponse = response
			const pointOfInterest = {
				...pointOfInterestResponse,
				id: queryParams.id
			}

			dispatch(
				actions.pointOfInterestFetchedToUpdate({
					entities: pointOfInterest
				})
			)
		})
		.catch(error => {
			console.log("can't fetch point of interest to update ", error)
			error.clientMessage = "Can't find point of interest to update"
			dispatch(actions.catchError({ error, callType: callTypes.list }))
		})
}

// ━━━━━━━━━━━━━━━━━━━━━━━━ Anchors Position ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━ \\

export const fetchAnchorsPosition = queryParams => dispatch => {
	dispatch(actions.startCall({ callType: callTypes.list }))

	if (!queryParams) {
		dispatch(actions.anchorsPositioningFetched({ entities: [] }))
	}

	return requestFromServer
		.getAnchorsCollection(queryParams)
		.then(response => {
			if (!response) {
				throw Error("Can't make a request for server")
			}

			const anchorsFromDatabase = response

			dispatch(actions.anchorsPositioningFetched({ entities: anchorsFromDatabase }))
		})
		.catch(error => {
			console.log("fetch anchors", error)
			error.clientMessage = "Can't find anchors position"
			dispatch(actions.catchError({ error, callType: callTypes.list }))
		})
}

export const createAnchorPosition = queryParams => dispatch => {
	dispatch(actions.startCall({ callType: callTypes.action }))

	return requestFromServer
		.createAnchorOnDatabase(queryParams)
		.then(res => {
			// dispatch(
			//   actions.poiCreated({
			//     name: queryParams.data.name,
			//     description: queryParams.data.description,
			//     type: queryParams.data.type,
			//     networkId: queryParams.netId,
			//     created: {
			//       createdBy: queryParams.user,
			//       createdOn: firebase.firestore.FieldValue.serverTimestamp(),
			//     },
			//   })
			// );
			dispatch({
				type: "SNACKBAR_SUCCESS",
				payload: {
					message: "Anchor successfully planned"
				}
			})
			return res
		})
		.catch(error => {
			error.clientMessage = "Can't position Anchor"
			dispatch(actions.catchError({ error, callType: callTypes.action }))
		})
}

export const fetchToUpdateAnchorAction = queryParams => dispatch => {
	dispatch(actions.startCall({ callType: callTypes.action }))
	if (!queryParams) {
		dispatch(actions.anchorPositionFetchedToUpdate({ entities: [] }))
	}

	return requestFromServer
		.getAnchorToUpdate(queryParams)
		.then(response => {
			if (!response) {
				throw Error("Can't make a request for server")
			}

			const anchorsResponse = response.data()
			const newAnchorsData = {
				...anchorsResponse,
				// id: queryParams.id
				id: queryParams.uuid
			}

			dispatch(
				actions.anchorPositionFetchedToUpdate({
					entities: newAnchorsData
				})
			)
		})
		.catch(error => {
			console.log("can't fetch Anchors to update ", error)
			error.clientMessage = "Can't find Anchors to update"
			dispatch(actions.catchError({ error, callType: callTypes.list }))
		})
}

// update anchor
export const updateAnchorPosition = queryParams => dispatch => {
	// console.log("🚀 ~ updateAnchorPosition ~ queryParams:", queryParams)
	dispatch(actions.startCall({ callType: callTypes.action }))

	return requestFromServer
		.updateAnchor(queryParams)
		.then(res => {
			dispatch({
				type: "SNACKBAR_SUCCESS",
				payload: {
					message: "Anchor updates"
				}
			})
			return res
		})
		.catch(error => {
			console.log(error, "error")
			error.clientMessage = "Can't update Anchor"
			dispatch(actions.catchError({ error, callType: callTypes.action }))
		})
}

// update anchor
// export const approveAnchorPosition = queryParams => dispatch => {
// 	dispatch(actions.startCall({ callType: callTypes.action }))

// 	return requestFromServer
// 		.approveAnchor(queryParams)
// 		.then(res => {
// 			dispatch({
// 				type: "SNACKBAR_SUCCESS",
// 				payload: `Anchors approved.`
// 			})
// 			return res
// 		})
// 		.catch(error => {
// 			console.log(error, "error")
// 			error.clientMessage = "Can't approve anchors"
// 			dispatch(actions.catchError({ error, callType: callTypes.action }))
// 		})
// }

export const deleteAnchor = queryParams => dispatch => {
	dispatch(actions.startCall({ callType: callTypes.action }))
	return requestFromServer
		.deleteAnchorFromDatabase(queryParams)
		.then(response => {
			dispatch(actions.anchorDeleted({ id: queryParams.id }))

			dispatch({
				type: "SNACKBAR_SUCCESS",
				payload: `Anchor ${queryParams.uuid} deleted`
			})
		})
		.catch(error => {
			error.clientMessage = "Can't delete anchor"
			dispatch(actions.catchError({ error, callType: callTypes.action }))
		})
}
// update active anchor
export const updateActiveAnchorPosition = queryParams => dispatch => {
	dispatch(actions.startCall({ callType: callTypes.action }))

	return requestFromServer
		.updateActiveAnchor(queryParams)
		.then(res => {
			// console.log("🚀 ~ updateActiveAnchorPosition ~ res:", res)

			dispatch({
				type: "SNACKBAR_SUCCESS",
				payload: {
					message: "Active anchor successfully updated"
				}
			})
			return res
		})
		.catch(error => {
			console.log(error, "error")
			error.clientMessage = "Can't update Active anchor."
			dispatch(actions.catchError({ error, callType: callTypes.action }))
		})
}

// export const fetchActiveAnchorsPosition = queryParams => dispatch => {
// 	dispatch(actions.startCall({ callType: callTypes.list }))

// 	if (!queryParams) {
// 		dispatch(actions.activeAnchorsPositioningFetched({ entities: [] }))
// 	}

// 	return requestFromServer
// 		.getActiveAnchorsCollection(queryParams)
// 		.then(response => {
// 			if (!response) {
// 				throw Error("Can't make a request for server")
// 			}

// 			const activeAnchorsFromDatabase = convertCollectionSnapshotToMap(response)

// 			dispatch(actions.activeAnchorsPositioningFetched({ entities: activeAnchorsFromDatabase }))
// 		})
// 		.catch(error => {
// 			console.log("fetch Active anchors ", error)
// 			error.clientMessage = "Can't find Active anchors"
// 			dispatch(actions.catchError({ error, callType: callTypes.list }))
// 		})
// }

export const deleteSeveralAnchors = queryParams => dispatch => {
	dispatch(actions.startCall({ callType: callTypes.action }))
	return requestFromServer
		.deleteSeveralAnchorsFromDatabase(queryParams)
		.then(response => {
			queryParams &&
				queryParams.selectedData.forEach(val => {
					dispatch(actions.anchorDeleted({ id: val.id }))
				})
			dispatch({
				type: "SNACKBAR_ERROR",
				payload: {
					message: "Anchors successfully deleted"
				}
			})
		})
		.catch(error => {
			error.clientMessage = "Can't delete several anchors"
			dispatch(actions.catchError({ error, callType: callTypes.action }))
		})
}

export const unplaceAnchors = queryParams => dispatch => {
	dispatch(actions.startCall({ callType: callTypes.action }))
	return requestFromServer
		.unplaceAnchorsFromDatabase(queryParams)
		.then(response => {
			dispatch(actions.anchorsUnplaced({ ids: queryParams.ids }))

			dispatch({
				type: "SNACKBAR_SUCCESS",
				payload: `Unplaced successfully.`
			})
			// console.log("🚀 ~ unplaceAnchors ~ response:", response)
		})
		.catch(error => {
			error.clientMessage = "Can't delete several anchors"
			dispatch(actions.catchError({ error, callType: callTypes.action }))
		})
}

export const updateAnchor = queryParams => dispatch => {
	// console.log("🚀 ~ updateAnchor ~ queryParams:", queryParams)
	dispatch(actions.startCall({ callType: callTypes.action }))

	return requestFromServer
		.updateAnchorStatus(queryParams)
		.then(res => {
			dispatch({
				type: "SNACKBAR_SUCCESS",
				payload: `Anchor updated`
			})
			return res
		})
		.catch(error => {
			console.log(error, "error")
			error.clientMessage = "Can't update Anchor"
			dispatch(actions.catchError({ error, callType: callTypes.action }))
		})
}

export const approveNodes = queryParams => dispatch => {
	dispatch(actions.startCall({ callType: callTypes.action }))

	return requestFromServer
		.approveNodes(queryParams)
		.then(response => {
			if (!response) throw Error("Can't make a request for server")
			return response.json()
		})
		.then(result => {
			return result
		})
		.catch(error => {
			// console.log("🪲 ~ getNodes ~ error:", error)
			console.log("Get Nodes: ", error)
			error.clientMessage = "Can't get nodes"
			dispatch(actions.catchError({ error, callType: callTypes.action }))
			// queryParams.onHide()
		})
}
